import { useMemo } from 'react';
import { GroupSectionData } from '@ui/ElementList/list.model';
import { OneOfListElements } from '@shared/models/project.model';
import { useSortElementsBy } from '@client/hooks/use-filter-elements.hooks';
import { getConversionFactorValue } from '@shared/helpers/conversion-factors.helpers';
import { GroupSectionMeta } from '../element-grouping.model';

export const useSortGroupSections = (
  sections: GroupSectionData<OneOfListElements, GroupSectionMeta>[],
): GroupSectionData<OneOfListElements, GroupSectionMeta>[] => {
  const sortBy = useSortElementsBy();
  return useMemo(() => {
    switch (sortBy) {
      case 'co2':
        return [...sections].sort(
          (a, b) =>
            getConversionFactorValue(b.meta.resultsSum, 'co2e') -
            getConversionFactorValue(a.meta.resultsSum, 'co2e'),
        );
      case 'cost':
        return [...sections].sort(
          (a, b) =>
            getConversionFactorValue(b.meta.resultsSum, 'sek') -
            getConversionFactorValue(a.meta.resultsSum, 'sek'),
        );
      default:
        return sections;
    }
  }, [sections, sortBy]);
};
